/**
 * 로그인 퍼널 내부 링크에 복귀지(`?redirect=`)를 실어 보내는 단일 빌더.
 * 복귀지는 두 매체로 운반된다 — URL `redirect`(라우터 내부 이동, 단일 진실) · sessionStorage returnUrl(OAuth 전체 이동 직전에만 클릭 시 보존).
 * 퍼널 안 이동(로그인 ↔ 가입 ↔ 인증 안내)은 이 함수로 URL 을 만들어 첫 홉에서 복귀지가 사라지지 않게 한다.
 * `redirect` 는 safeInternalPath 를 통과한 내부 경로만 넘긴다.
 */
export function withRedirect(
  path: string,
  redirect: string | null | undefined,
  extra?: Record<string, string>,
): string {
  const query = new URLSearchParams(extra);
  if (redirect) query.set('redirect', redirect);
  const qs = query.toString();
  return qs ? `${path}?${qs}` : path;
}
